import React, { useState } from 'react';

import PageLayout from './../layouts/PageLayout';
import { emailValidation, firstNameValidation, noSpaceValidation, phoneOnChange, phoneValidation } from '../validation';

const PHONE = "2508996660";
const PHONE_LINK = "tel:+12508996660";
const EMAIL = "Cleanairkelowna@gmail.com";
const ADDRESS = "140 Taylor Road, Kelowna, BC V1X 4E9";
const TIKTOK_URL = "https://www.tiktok.com/@kelownaductcleani";
const INSTAGRAM_URL = "https://www.instagram.com/kelownaductcleaning?igsh=eDhzNzZpYnJmNnhk&utm_source=qr";

function ContactUs() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState();
  const [message, setMessage] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isPhonenumberError, setIsPhonenumberError] = useState(false);

  function openEmailCompose(e) {
    e.preventDefault();
    if (firstName.length > 2 && emailValidation(email) && phoneValidation(phonenumber)) {
      const subject = encodeURIComponent(`Quote request from ${firstName} ${lastName}`);
      const bodyLines = [
        `Name: ${firstName} ${lastName}`,
        `Email: ${email}`,
        `Phone: ${phonenumber || ''}`,
        '',
        `Message: ${message || ''}`,
      ];
      const body = encodeURIComponent(bodyLines.join('\n'));
      window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    } else {
      if (!firstNameValidation(firstName)) setIsFirstNameError(true);
      else if (!emailValidation(email)) setIsEmailError(true);
      else if (!phoneValidation(phonenumber)) setIsPhonenumberError(true);
    }
  }

  function handleFirstName(e) { setIsFirstNameError(false); setFirstName(e.target.value); }
  function handleLastName(e) { setLastName(e.target.value); }
  function handleEmail(e) { noSpaceValidation(e.target.value) && setEmail(e.target.value); setIsEmailError(false); }
  function handlePhonenumber(e) { setIsPhonenumberError(false); phoneOnChange(e.target.value) && setPhonenumber(e.target.value); }
  function handleMessage(e) { setMessage(e.target.value); }

  return (
    <>
      <div className="page-content">
        <PageLayout desc={false} pageTitle="Contact Us" />
        <section className="content-inner contact-form-wraper style-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-7 col-lg-7">
                <div className="contact-box">
                  <div className="card">
                    <div className="card-body">
                      <div className="mb-4">
                        <h2 className="mb-0">Get In Touch</h2>
                        <p className="mb-0 font-18 text-primary">
                          Request a free quote for duct cleaning or dryer vent cleaning in Kelowna & the Okanagan.
                        </p>
                      </div>
                      <form className="dzForm" onSubmit={openEmailCompose}>
                        <div className="dzFormMsg"></div>
                        <div className="row">
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input name="dzFirstName" type="text" className="form-control" placeholder="First Name" value={firstName} onChange={handleFirstName} />
                            {isFirstNameError && <p style={{ color: 'red', fontSize: '12px' }}>Please enter a name with at least 2 characters.</p>}
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input name="dzLastName" type="text" className="form-control" placeholder="Last Name" value={lastName} onChange={handleLastName} />
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input name="dzEmail" type="text" className="form-control" placeholder="Email Address" value={email} onChange={handleEmail} />
                            {isEmailError && <p style={{ color: 'red', fontSize: '12px' }}>Please enter a valid email.</p>}
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input name="dzPhoneNumber" type="text" className="form-control" placeholder="Phone Number" value={phonenumber} onChange={handlePhonenumber} />
                            {isPhonenumberError && <p style={{ color: 'red', fontSize: '12px' }}>Please enter a valid phone number.</p>}
                          </div>
                          <div className="col-xl-12 mb-3 mb-md-4">
                            <textarea name="dzMessage" className="form-control" placeholder="Message" value={message} onChange={handleMessage}></textarea>
                          </div>
                          <div className="col-xl-12">
                            <button name="submit" type="submit" value="Submit" className="btn btn-primary">
                              Send via Email
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 m-b30">
                <div className="info-box">
                  <div className="info">
                    <h2>Contact Information</h2>
                    <p className="font-18">Fill out the form and our team will get back to you within 24 hours.</p>
                  </div>

                  <div className="widget widget_about">
                    <div className="widget widget_getintuch">
                      <ul>
                        <li>
                          <i className="fa fa-phone"></i>
                          <span><a href={PHONE_LINK}>{PHONE.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}</a></span>
                        </li>
                        <li>
                          <i className="fa fa-envelope"></i>
                          <span><a href={`mailto:${EMAIL}`}>{EMAIL}</a></span>
                        </li>
                        <li>
                          <i className="fas fa-map-marker-alt"></i>
                          <span>{ADDRESS}</span>
                        </li>
                        <li>
                          <i className="fa-brands fa-instagram"></i>
                          <span><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">@kelownaductcleaning</a></span>
                        </li>
                        <li>
                          <i className="fa-brands fa-tiktok"></i>
                          <span><a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer">@kelownaductcleani</a></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default ContactUs;
